module.exports = "<vb-generic-selection-input\r\n  inputId=\"dosage-form-input\"\r\n  label=\"Darreichungsform\"\r\n  [items]=\"dosageFormList\"\r\n  [selectedItem]=\"item\"\r\n  [ctrl]=\"control\">\r\n</vb-generic-selection-input>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/store-management/medicine/dosage-form-selection/dosage-form-selection.component.html
// module id = ./src/app/store-management/medicine/dosage-form-selection/dosage-form-selection.component.html
// module chunks = main